import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db36cec8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll-content p-p3" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"120px"} }, null, -1))
const _hoisted_4 = { class: "p-p-3 shadow policy-footer" }
const _hoisted_5 = { class: "form-check" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "agreeMarketingCheckbox"
}, "ต้องการรับกิจกรรมทางการตลาด", -1))
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "agreePolicyCheckbox"
}, "ยอมรับเงื่อนไขและนโยบาย ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "p-m-3 text-justify",
        innerHTML: _ctx.policy
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agreeMargeting) = $event)),
            type: "checkbox",
            class: "form-check-input",
            id: "agreeMarketingCheckbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.agreeMargeting]
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.agreePolicy) = $event)),
            type: "checkbox",
            class: "form-check-input",
            id: "agreePolicyCheckbox"
          }, null, 512), [
            [_vModelCheckbox, _ctx.agreePolicy]
          ]),
          _hoisted_8
        ]),
        _createVNode(_component_Button, {
          class: "bg-black w-100 p-mt-3",
          label: "ต่อไป",
          disabled: !_ctx.agreePolicy,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmit()))
        }, null, 8, ["disabled"])
      ])
    ])
  ]))
}